export { default } from './TableIllustration';
